import './forms.css'
import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { FormGroup, Row, Col } from 'react-bootstrap'
import Button from 'elements/CustomButton/CustomButton.jsx'
import { renderField } from './_fieldRenderer'

class VariantForm extends React.Component {

    render() {
        const { handleSubmit, submitting } = this.props

        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <Field
                                name='name'
                                type='text'
                                component={renderField}
                                label='Nome'
                                placeholder='Nome'
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Button
                            style={{ width: '100%', marginTop: 10 }}
                            bsStyle='danger'
                            type='button'
                            disabled={submitting}
                            onClick={this._handleCancel}
                            wd
                        >
                            Cancelar
                         </Button>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Button
                            style={{ width: '100%', marginTop: 10 }}
                            bsStyle='default'
                            type='submit'
                            disabled={submitting}
                            fill
                        >
                            Salvar
                         </Button>
                    </Col>
                </Row>
            </form >
        )
    }

    _handleCancel = () => {
        this.props.reset() //form reset - redux-form action creator
        this.props.handleCancel() //function passed via props
    }

}

const validate = values => {
    const errors = {}
    if (!values.name) { errors.name = 'Obrigatório' }

    return errors
}

VariantForm = reduxForm({ form: 'VariantForm', validate })(VariantForm)
export default VariantForm



// WEBPACK FOOTER //
// ./src/forms/VariantForm.jsx